import { render } from "./NotificacionesCampana.vue?vue&type=template&id=10e876df&scoped=true"
import script from "./NotificacionesCampana.vue?vue&type=script&lang=js"
export * from "./NotificacionesCampana.vue?vue&type=script&lang=js"

import "./NotificacionesCampana.vue?vue&type=style&index=0&id=10e876df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e876df"]])

export default __exports__